import { CloseButton, Table, Text, Tooltip } from '@mantine/core';
import { IconEdit, IconRowRemove } from '@tabler/icons-react';
import { DeleteModal } from '../../../components/DeleteModal';
import { useModal } from '../../../hooks/useModal';
import { defaultIconStyle } from '../../../theme/styling/iconStyling';
import { mutate } from '../../../util/api/mutate';
import type { OrganisationDto } from '../../../util/types/OrganisationDto';
import { EditOrganisationModal } from './EditOrganisationModal';
import { KeyedRow } from '../../../components/KeyedRow';

interface OrgnisationTableRowProps {
	org: OrganisationDto;
	triggerListUpdate: () => void;
}

export function OrganisationTableRow({
	org,
	triggerListUpdate,
}: OrgnisationTableRowProps) {
	const editModal = useModal();
	const deleteModal = useModal();

	const deleteOrgMutation = mutate<OrganisationDto>(
		`organisation/delete/${org.id}`,
	);

	return (
		<>
			<KeyedRow>
				<Table.Td>{org.name}</Table.Td>
				<Table.Td>{org.urlValue}</Table.Td>
				<Table.Td>{org.phoneNumber}</Table.Td>
				<Table.Td>{org.email}</Table.Td>
				<Table.Td width={'20vw'}>
					<Tooltip label={org.connectionString}>
						<Text truncate={'end'} size={'0.8rem'} w={'20vw'} h={'21px'} pt={4}>
							{org.connectionString}
						</Text>
					</Tooltip>
				</Table.Td>
				<Table.Td>
					<CloseButton
						icon={<IconEdit {...defaultIconStyle} />}
						onClick={() => editModal.open()}
					/>
				</Table.Td>
				<Table.Td>
					<CloseButton
						icon={<IconRowRemove {...defaultIconStyle} />}
						onClick={() => deleteModal.open()}
					/>
				</Table.Td>
			</KeyedRow>
			<EditOrganisationModal
				close={editModal.close}
				opened={editModal.isOpen}
				triggerListUpdate={triggerListUpdate}
				organisation={{
					...org,
				}}
			/>
			<DeleteModal
				isOpened={deleteModal.isOpen}
				close={deleteModal.close}
				titleType={'Organisation'}
				itemDescription={org.name}
				mutation={deleteOrgMutation}
				onComplete={() => triggerListUpdate()}
			/>
		</>
	);
}
